import { render } from "./Sidebar.vue?vue&type=template&id=1cf1ab03"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/prod.storm.ms/actions-runner/storm-site/storm-site/storm-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__